import React from 'react';
import { useSearchParams } from 'react-router-dom';
import SectionTabs, { SectionTab } from '../components/SectionTabs';
import { PageHeader } from '../components/ui';
import VineyardMaintenance from './VineyardMaintenance';
import Vineyards from './Vineyards';

const VINEYARD_TABS: SectionTab[] = [
  { id: 'vineyards', label: 'Vineyards' },
  { id: 'maintenance', label: 'Vineyard Maintenance' }
];

const VineyardSection: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const current = searchParams.get('tab');
  const activeTab = current === 'maintenance' ? 'maintenance' : 'vineyards';

  const handleTabChange = (id: string) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', id);
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="space-y-7">
      <PageHeader
        title="Vineyards"
        subtitle="Manage your vineyards and their maintenance from a single view."
      />

      <SectionTabs
        tabs={VINEYARD_TABS}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      {/* Content: mount all subtabs once and just toggle visibility; refetch when tab becomes visible */}
      <div>
        <div hidden={activeTab !== 'vineyards'}>
          <Vineyards tabVisible={activeTab === 'vineyards'} />
        </div>
        <div hidden={activeTab !== 'maintenance'}>
          <VineyardMaintenance tabVisible={activeTab === 'maintenance'} />
        </div>
      </div>
    </div>
  );
};

export default VineyardSection;


